/**
 * Gets the value of a nested property using dot notation
 * @param object The object to search in
 * @param path The path to the property using dot notation (e.g., 'author.name')
 * @returns The value at the specified path or undefined if not found
 */
function getNestedValue(object: unknown, path: string) {
  const keys = path.split('.');
  let value = object;

  for (const key of keys) {
    if (value === null || value === undefined) return undefined;
    value = (value as Record<string, unknown>)[key];
  }

  return value;
}

export default getNestedValue;
